import { Post } from './types'

export const fetchPosts = async (endpoint: string): Promise<{ posts: Post[]; property: string }> => {
    try {
        const response = await fetch(endpoint)
        const { data } = await response.json()
        return data
    } catch (error) {
        return { posts: [], property: '' }
    }
}
